import { useMemo } from '@wordpress/element';
import { useGiveaway } from './GiveawayProvider';
import GiveawayStickerBundle from './GiveawayStickerBundle';

function getFloatingGroupKey(token) {
    return [
        token?.sourceType || '',
        token?.sourceSlot || token?.slot || '',
    ].join(':');
}

export default function FloatingStickerToken() {
    const { floatingTokens, openToken, showLogin, showCollect } = useGiveaway();

    const groups = useMemo(() => {
        const map = new Map();

        (floatingTokens || []).forEach((token) => {
            const key = getFloatingGroupKey(token);

            if (!map.has(key)) {
                map.set(key, []);
            }

            map.get(key).push(token);
        });

        return [...map.entries()].map(([key, tokens]) => ({
            key,
            tokens,
        }));
    }, [floatingTokens]);

    if (!groups.length || showLogin || showCollect) return null;

    return (
        <div className="bjnt-floating-sticker-stack">
            {groups.map((group, index) => (
                <div
                    key={group.key || index}
                    className="bjnt-floating-sticker-stack__item"
                    style={{ '--bjnt-floating-index': index }}
                >
                    <GiveawayStickerBundle
                        tokens={group.tokens}
                        variant="floating"
                        onClick={() => openToken({
                            ...group.tokens[0],
                            tokens: group.tokens,
                            packId: `${group.key}:${group.tokens.map((token) => token.claimToken).join('|')}`,
                        })}
                    />
                </div>
            ))}
        </div>
    );
}